export { default as ArrowCircleUpSolidIcon } from './ArrowCircleUpSolidIcon';
